function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, computed, watch, ref, getCurrentInstance } from "vue";
import { definePropType } from "@types-vue/props";
import TableList from "@/components/TableList/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import _ from "lodash";
import { messageStatusRecord, MeaasgeStatusType } from "@/api/message/message";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        msg_id: {
            type: Number,
            required: true
        },
        status: {
            type: definePropType(String),
            required: true
        }
    },
    components: {
        TableList: TableList,
        Pagination: Pagination
    },
    setup: function setup(props, param1) {
        var emit = param1.emit;
        var handleSizeChange = function handleSizeChange(page_size) {
            query.value.page_size = page_size;
            handelMessageStatusRecord();
        };
        var handleCurrentChange = function handleCurrentChange(page) {
            query.value.page = page;
            handelMessageStatusRecord();
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var loading = ref(false);
        var total = ref(0);
        var list = ref([]);
        var query = ref({
            page: 1,
            page_size: 15
        });
        var all_users = ref(false);
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var tableColumnConfig = computed(function() {
            return [
                {
                    label: "\u5E7F\u544A\u4E3B\u540D\u79F0",
                    prop: "adv_name"
                },
                {
                    label: "\u72B6\u6001",
                    prop: "status",
                    params: {
                        innerHTML: function(param) {
                            var row = param.row;
                            return props.status === MeaasgeStatusType.Read ? "\u5DF2\u8BFB" : "\u672A\u8BFB";
                        }
                    }
                }, 
            ];
        });
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                query.value.page = 1;
                query.value.page_size = 15;
                handelMessageStatusRecord();
            }
        }, {
            immediate: true
        });
        function handelMessageStatusRecord() {
            return _handelMessageStatusRecord.apply(this, arguments);
        }
        function _handelMessageStatusRecord() {
            _handelMessageStatusRecord = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            loading.value = true;
                            _ctx.next = 4;
                            return messageStatusRecord(_objectSpreadProps(_objectSpread({}, query.value), {
                                status: props.status,
                                msg_id: props.msg_id,
                                all_users: query.value.page === 1 ? undefined : all_users.value
                            }));
                        case 4:
                            res = _ctx.sent;
                            loading.value = false;
                            if (!(res.status !== 200)) {
                                _ctx.next = 9;
                                break;
                            }
                            root.$message.error("\u51FA\u9519\u4E86");
                            return _ctx.abrupt("return");
                        case 9:
                            list.value = _.get(res, "data.data.list") || [];
                            total.value = _.get(res, "data.data.total");
                            all_users.value = _.get(res, "data.data.all_users");
                            _ctx.next = 18;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            loading.value = false;
                            console.log(_ctx.t0);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }));
            return _handelMessageStatusRecord.apply(this, arguments);
        }
        return {
            dialogVisible: dialogVisible,
            loading: loading,
            query: query,
            list: list,
            total: total,
            tableColumnConfig: tableColumnConfig,
            handleSizeChange: handleSizeChange,
            handleCurrentChange: handleCurrentChange
        };
    }
});
